import showTime from './showTime.ts';
import addCompanyNameToComment from './addCompanyNameToComment.ts';
import appointmentSubmiter from './submiter.ts';
export{
    showTime,
    addCompanyNameToComment,
    appointmentSubmiter
}